// extracted by mini-css-extract-plugin
export default {"partnerItem":"partner-item_partnerItem__bjaHG","partnerImage":"partner-item_partnerImage__9oNTJ","small":"partner-item_small__ZkEI9"};